<div class="sd-dialog">
    <div class="sd-dialog__icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="7.25" stroke="currentColor" stroke-width="1.5" />
            <path d="M10 6.5V10l2.5 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>

    <h3 class="sd-dialog__title">Still there?</h3>
    <p class="sd-dialog__message">
        You've been inactive for a while. For your security, you'll be signed out in
        <strong class="sd-dialog__countdown">{{ timeLeft }}</strong>.
    </p>

    <div class="sd-dialog__progress" aria-hidden="true">
        <div class="sd-dialog__progress-fill" [style.width.%]="progress"></div>
    </div>

    <div class="sd-dialog__actions">
        <button type="button" class="sd-btn sd-btn--primary" ngbAutofocus (click)="staySignedIn()">Stay signed in</button>
    </div>
</div>
